import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { getStorageBasedFeature } from 'reactApp/appHelpers/featuresHelpers/utils';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

/** CLOUDWEB-18716 Отображать ли новую сетку */
export const hasNewTableGrid = (storage?: EStorageType) => getStorageBasedFeature('datalist-new-table-grid-storages', storage);

/** CLOUDWEB-18716 Скрывать ли дату изменения файла */
export const hideDateInNewTableGrid: boolean = getFeature('hide-date-in-new-table-grid') || false;

/** CLOUDWEB-18717 Анимации в новой сетке */
export const animateNewTableGrid: boolean = getFeature('animate-new-table-grid') || false;
